"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { YouTubeResponsive } from "@repo/design-system/components/ui/youtube-responsive";
import { cn } from "@repo/design-system/utils/cn";
import { useState } from "react";
import Play from "~/components/icons/play-eon";
import { useLanguage } from "~/translations/loader/use-language";
interface YouTubePlayerProps {
  className?: string;
  onVideoStart?: () => void;
  portrait?: boolean;
  thumbnailSrc?: string;
  videoId: string;
}
export default function YouTubePlayer(t0) {
  const $ = _c(16);
  const {
    videoId,
    thumbnailSrc,
    portrait: t1,
    onVideoStart,
    className
  } = t0;
  const portrait = t1 === undefined ? false : t1;
  const t = useLanguage();
  const [, setVideoStarted] = useState(false);
  const defaultThumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
  let t2;
  if ($[0] !== onVideoStart || $[1] !== setVideoStarted) {
    t2 = startVideo => {
      setVideoStarted(true);
      onVideoStart?.();
      startVideo();
    };
    $[0] = onVideoStart;
    $[1] = setVideoStarted;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleStartVideo = t2;
  let t3;
  if ($[3] !== className) {
    t3 = cn("print:hidden", className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== className || $[6] !== defaultThumbnail || $[7] !== handleStartVideo || $[8] !== portrait || $[9] !== t.jobad_diversity_youtubePlay || $[10] !== thumbnailSrc) {
    t4 = (startVideo_0, isLoading) => <button aria-busy={isLoading} aria-label={t.jobad_diversity_youtubePlay} className="group absolute inset-0 size-full cursor-pointer" onClick={() => handleStartVideo(startVideo_0)} title={t.jobad_diversity_youtubePlay} type="button"><CustomImage alt="Video thumbnail - Click to play" className={cn("h-full w-full transition-opacity duration-300", portrait ? "bg-card object-contain" : "object-cover", className)} fill={true} sizes="(min-width: 1280px) 853px, 100vw" src={thumbnailSrc || defaultThumbnail} /><div className={cn("absolute inset-0 bg-black transition-opacity duration-300", "opacity-0 group-hover:opacity-20")} /><div className="absolute inset-0 flex items-center justify-center"><div className="rounded-2xl bg-muted-foreground p-2 transition-colors duration-300 group-hover:bg-primary"><Play className="size-10 text-white transition-all duration-300 group-hover:scale-105" /></div></div></button>;
    $[5] = className;
    $[6] = defaultThumbnail;
    $[7] = handleStartVideo;
    $[8] = portrait;
    $[9] = t.jobad_diversity_youtubePlay;
    $[10] = thumbnailSrc;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== videoId) {
    t5 = <YouTubeResponsive className={t3} videoId={videoId}>{t4}</YouTubeResponsive>;
    $[12] = t3;
    $[13] = t4;
    $[14] = videoId;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}